import React, { useContext } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import styles from './pageDescription.module.css';
import { MobileContext } from '../../domain/context/MobileContext';

import { getDescription } from '../../domain/state/metadata/selectors';

interface StateProps {
  description: string;
}

const mapStateToProps = (state) => ({
  description: getDescription(state),
});

interface OwnProps {
  className?: string;
}

export const PageDescription = connect<StateProps, TPseudoObject, OwnProps>(
  mapStateToProps,
)((props: StateProps & OwnProps) => {
  const { className, description } = props;
  const isMobile = useContext(MobileContext);
  return description ? (
    <div
      className={classnames(styles.description, className, {
        [styles.descriptionMobile]: isMobile,
      })}
      dangerouslySetInnerHTML={{ __html: description }}
    />
  ) : null;
});
